import { Client } from '@/utils';
import { resource as resourceAPI } from '@/api';

const LOAD_RESOURCE = 'resource/LOAD_RESOURCE';
const LOAD_ABILITY = 'resource/LOAD_ABILITY';
const EDIT_RESOURCE = 'resource/EDIT_RESOURCE';
const EDIT_ABILITY = 'resource/EDIT_ABILITY';
const TOGGLE_FOLD = 'resource/TOGGLE_FOLD';
const TOGGLE_HIDE = 'resource/TOGGLE_HIDE';
const START_VALID = 'resource/START_VALID';
const STOP_VALID = 'resource/STOP_VALID';
const TOGGLE_VALID = 'resource/TOGGLE_VALID';
const TOGGLE_LOADED = 'resource/TOGGLE_LOADED';
const TOGGLE_REFRESHING = 'resource/TOGGLE_REFRESHING';

function getResourceList(resList, parentValid) {
  let resourceList = [];
  resList.forEach((item) => {
    const hasChildren = item.resType < 3 && item.children && item.children.length > 0;
    resourceList.push({
      ...item,
      hasChildren,
      isFold: false,
      isHide: false,
      canValid: !!parentValid,
    });
    if (hasChildren && item.resType < 3) {
      resourceList = resourceList.concat(getResourceList(item.children, item.valid));
    }
  });
  return resourceList;
}

export default {
  state: {
    loaded: false,
    refreshing: false,
    activeTab: '',
    systemResources: [],
    funcList: [],
    funcCandidates: [],
    funcValues: [],
  },
  actions: {
    async [LOAD_RESOURCE]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_RESOURCE, await Client.get(resourceAPI.query, { params }, frontCode));
    },
    async [LOAD_ABILITY]({ commit }, { params = {}, frontCode = '' } = {}) {
      commit(LOAD_ABILITY, await Client.get(resourceAPI.queryAbility, { params }, frontCode));
    },
    async [EDIT_RESOURCE]({ commit }, { data = {}, $index, index, frontCode = '' }) {
      commit(EDIT_RESOURCE, {
        index,
        $index,
        data: await Client.post(resourceAPI.orderUpdate, { data }, frontCode),
      });
    },
    async [EDIT_ABILITY]({ commit }, { data = {}, frontCode = '' } = {}) {
      commit(EDIT_ABILITY, await Client.post(resourceAPI.updateAbility, { data }, frontCode));
    },
    async [START_VALID]({ commit }, { data = {}, $index, index, resType, frontCode = '' }) {
      commit(TOGGLE_VALID, {
        index,
        $index,
        resType,
        data: await Client.post(resourceAPI.validRes, {
          data: {
            ...data,
            valid: 1,
          },
        }, frontCode),
      });
    },
    async [STOP_VALID]({ commit }, { data = {}, $index, index, resType, frontCode = '' }) {
      commit(TOGGLE_VALID, {
        index,
        $index,
        resType,
        data: await Client.post(resourceAPI.validRes, {
          data: {
            ...data,
            valid: 0,
          },
        }, frontCode),
      });
    },
  },
  /* eslint-disable no-param-reassign, max-len */
  mutations: {
    [LOAD_RESOURCE](state, { sysList, currentSysId, resList }) {
      if (sysList.length === 0) {
        state.systemResources = [];
      } else {
        const hasChildren = resList && resList.length > 0;
        const systemResources = sysList.map(item => ({
          id: item.bizId,
          name: item.resName,
          resourceList: [{
            ...item,
            hasChildren,
            canValid: 1,
          }],
        }));
        for (let i = 0; i < systemResources.length; i++) {
          if (systemResources[i].id === currentSysId) {
            if (hasChildren) {
              systemResources[i].resourceList = systemResources[i].resourceList.concat(getResourceList(resList, systemResources[i].resourceList[0].valid));
            }
            break;
          }
        }
        state.activeTab = currentSysId.toString();
        state.systemResources = systemResources;
      }
    },
    [LOAD_ABILITY](state, data) {
      state.funcList = data;
      state.funcCandidates = data.map(item => item.id);
      state.funcValues = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].valid === 1) {
          state.funcValues.push(data[i].id);
        }
      }
    },
    [TOGGLE_HIDE](state, { index, $index }) {
      const targetList = state.systemResources[index].resourceList;
      targetList[$index].isHide = !targetList[$index].isHide;
    },
    [TOGGLE_FOLD](state, { index, $index }) {
      const targetList = state.systemResources[index].resourceList;
      targetList[$index].isFold = !targetList[$index].isFold;
    },
    [EDIT_RESOURCE](state, { index, $index, data }) {
      const targetList = state.systemResources[index].resourceList;
      targetList.splice($index, 1, {
        ...targetList[$index],
        ...data,
      });
    },
    [EDIT_ABILITY](state) {
      state.funcList = [];
      state.funcValues = [];
    },
    [TOGGLE_VALID](state, { index, $index, resType, data }) {
      const { valid, operatorInfo, modifyTime } = data;
      const targetList = state.systemResources[index].resourceList;
      const targetResource = targetList[$index];
      switch (resType) {
        case 1:
          for (let i = 1; i < targetList.length; i++) {
            targetList[i].canValid = valid;
            targetList[i].valid = valid;
            targetList[i].operatorInfo = operatorInfo;
            targetList[i].modifyTime = modifyTime;
          }
          break;
        case 2: {
          const { children } = targetResource;
          if (children && children.length > 0) {
            for (let i = $index + 1; i < $index + 1 + children.length; i++) {
              targetList[i].canValid = valid;
              targetList[i].valid = valid;
              targetList[i].operatorInfo = operatorInfo;
              targetList[i].modifyTime = modifyTime;
            }
          }
          break;
        }
        default:
      }
      targetList.splice($index, 1, {
        ...targetResource,
        ...data,
      });
    },
    [TOGGLE_LOADED](state, data) {
      state.loaded = data;
    },
    [TOGGLE_REFRESHING](state, data) {
      state.refreshing = data;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/resource.js